import { render, staticRenderFns } from "./DeliveryEditDlg.vue?vue&type=template&id=45a2f55c&scoped=true"
import script from "./DeliveryEditDlg.vue?vue&type=script&lang=js"
export * from "./DeliveryEditDlg.vue?vue&type=script&lang=js"
import style0 from "./DeliveryEditDlg.vue?vue&type=style&index=0&id=45a2f55c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45a2f55c",
  null
  
)

export default component.exports